import { render, staticRenderFns } from "./link-item.vue?vue&type=template&id=3eb0f93e&scoped=true&"
import script from "./link-item.vue?vue&type=script&lang=js&"
export * from "./link-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb0f93e",
  null
  
)

export default component.exports